function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseWalletAdapter, LoginStateEnum, PORTKEY_ORIGIN_CHAIN_ID_KEY, makeError, ERR_CODE, ConnectedWallet, enhancedLocalStorage } from '@aelf-web-login/wallet-adapter-base';
import { did, managerApprove, getChain } from '@portkey/did-ui-react';
import { aes } from '@portkey/utils';
import { getContractBasic } from '@portkey/contracts';
export var PortkeyAAName = 'PortkeyAA';
export var PortkeyAAWallet = /*#__PURE__*/function (_BaseWalletAdapter) {
  _inherits(PortkeyAAWallet, _BaseWalletAdapter);
  var _super = _createSuper(PortkeyAAWallet);
  function PortkeyAAWallet(config) {
    var _this;
    _classCallCheck(this, PortkeyAAWallet);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "name", PortkeyAAName);
    _defineProperty(_assertThisInitialized(_this), "icon", 'data:image/svg+xml;base64,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');
    _defineProperty(_assertThisInitialized(_this), "_loginState", void 0);
    _defineProperty(_assertThisInitialized(_this), "_wallet", void 0);
    _defineProperty(_assertThisInitialized(_this), "_config", void 0);
    _this._loginState = LoginStateEnum.INITIAL;
    _this._wallet = null;
    _this._config = config;
    _this.autoRequestAccountHandler();
    return _this;
  }
  _createClass(PortkeyAAWallet, [{
    key: "loginState",
    get: function get() {
      return this._loginState;
    }
  }, {
    key: "noNeedForConfirm",
    get: function get() {
      return this._config.noNeedForConfirm;
    }
  }, {
    key: "wallet",
    get: function get() {
      return this._wallet;
    }
  }, {
    key: "appName",
    get: function get() {
      var compatibleAppName = "V2-".concat(this._config.appName);
      if (enhancedLocalStorage.getItem(compatibleAppName)) {
        return compatibleAppName;
      } else {
        return this._config.appName;
      }
    }
  }, {
    key: "autoRequestAccountHandler",
    value: function () {
      var _autoRequestAccountHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var canLoginEargly;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              canLoginEargly = !!enhancedLocalStorage.getItem(this._config.appName) || !!enhancedLocalStorage.getItem("V2-".concat(this._config.appName));
              if (canLoginEargly) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (this._config.autoShowUnlock) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              console.log('this._config.autoShowUnlock', this._config.autoShowUnlock);
              _context.next = 8;
              return this.loginEagerly();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function autoRequestAccountHandler() {
        return _autoRequestAccountHandler.apply(this, arguments);
      }
      return autoRequestAccountHandler;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(didWalletInfo) {
        var _didWalletInfo$caInfo2, _didWalletInfo$caInfo3, chainId, _didWalletInfo$caInfo, caInfo, nickName, holderInfo, portkeyInfo;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              enhancedLocalStorage.setItem(PORTKEY_ORIGIN_CHAIN_ID_KEY, didWalletInfo.chainId);
              this._loginState = LoginStateEnum.CONNECTING;
              chainId = this._config.chainId;
              if (!(didWalletInfo.chainId !== chainId)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return did.didWallet.getHolderInfoByContract({
                caHash: (_didWalletInfo$caInfo = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo === void 0 ? void 0 : _didWalletInfo$caInfo.caHash,
                chainId: chainId
              });
            case 7:
              caInfo = _context2.sent;
              didWalletInfo.caInfo.caAddress = caInfo === null || caInfo === void 0 ? void 0 : caInfo.caAddress;
            case 9:
              nickName = 'Wallet 01';
              _context2.prev = 10;
              _context2.next = 13;
              return did.getCAHolderInfo(didWalletInfo.chainId);
            case 13:
              holderInfo = _context2.sent;
              nickName = holderInfo.nickName;
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](10);
              console.log('portkeyAA login and execute did.getCAHolderInfo. nickName:', nickName, _context2.t0);
            case 20:
              _context2.prev = 20;
              _context2.next = 23;
              return did.save(didWalletInfo.pin, this.appName);
            case 23:
              _context2.next = 29;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t1 = _context2["catch"](20);
              console.log('portkeyAA login and execute did.save.', _context2.t1);
              throw _context2.t1;
            case 29:
              portkeyInfo = _objectSpread(_objectSpread({}, didWalletInfo), {}, {
                accounts: _defineProperty({}, chainId, (_didWalletInfo$caInfo2 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo2 === void 0 ? void 0 : _didWalletInfo$caInfo2.caAddress),
                nickName: nickName
              });
              this._wallet = {
                name: nickName,
                address: (_didWalletInfo$caInfo3 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo3 === void 0 ? void 0 : _didWalletInfo$caInfo3.caAddress,
                extraInfo: {
                  publicKey: (didWalletInfo === null || didWalletInfo === void 0 ? void 0 : didWalletInfo.walletInfo.keyPair.getPublic('hex')) || '',
                  portkeyInfo: portkeyInfo
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              this.emit('connected', this._wallet);
              return _context2.abrupt("return", this._wallet);
            case 37:
              _context2.prev = 37;
              _context2.t2 = _context2["catch"](0);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_LOGIN_FAIL, _context2.t2));
              return _context2.abrupt("return");
            case 42:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 37], [10, 17], [20, 25]]);
      }));
      function login(_x) {
        return _login.apply(this, arguments);
      }
      return login;
    }() // TODO: will be execute emit first, then execute onLockHandler, Set a delay first and optimize later
  }, {
    key: "loginEagerly",
    value: function () {
      var _loginEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              setTimeout(function () {
                _this2.emit('lock');
              }, 1000);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function loginEagerly() {
        return _loginEagerly.apply(this, arguments);
      }
      return loginEagerly;
    }()
  }, {
    key: "lock",
    value: function lock() {
      if (!this._wallet) {
        throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
      }
      did.reset();
      this._wallet = null;
      this._loginState = LoginStateEnum.INITIAL;
      this.emit('disconnected', true);
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var originChainId;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              originChainId = enhancedLocalStorage.getItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              if (originChainId) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return did.logout({
                chainId: originChainId
              }, {
                onMethod: 'transactionHash'
              });
            case 6:
              this._wallet = null;
              this._loginState = LoginStateEnum.INITIAL;
              enhancedLocalStorage.removeItem(ConnectedWallet);
              enhancedLocalStorage.removeItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              enhancedLocalStorage.removeItem(this.appName);
              this.emit('disconnected');
              _context4.next = 17;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](0);
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_LOGOUT_FAIL, _context4.t0));
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 14]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "checkPassword",
    value: function () {
      var _checkPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(keyName, password) {
        var aesStr;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return did.didWallet._storage.getItem(keyName || did.didWallet._defaultKeyName);
            case 3:
              aesStr = _context5.sent;
              if (!aesStr) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", !!aes.decrypt(aesStr, password));
            case 6:
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", false);
            case 11:
              return _context5.abrupt("return", false);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 8]]);
      }));
      function checkPassword(_x2, _x3) {
        return _checkPassword.apply(this, arguments);
      }
      return checkPassword;
    }()
  }, {
    key: "onUnlock",
    value: function () {
      var _onUnlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(password) {
        var _caInfo, _didWalletInfo$caInfo4, _didWalletInfo$caInfo5, appName, chainId, isValidPinCode, localWallet, caInfo, caHash, key, originChainId, nickName, holderInfo, didWalletInfo, portkeyInfo;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              appName = this.appName;
              chainId = this._config.chainId;
              _context6.next = 5;
              return this.checkPassword(appName, password);
            case 5:
              isValidPinCode = _context6.sent;
              if (isValidPinCode) {
                _context6.next = 8;
                break;
              }
              return _context6.abrupt("return");
            case 8:
              _context6.next = 10;
              return did.load(password, appName);
            case 10:
              localWallet = _context6.sent;
              caInfo = localWallet.didWallet.caInfo[chainId];
              caHash = (_caInfo = caInfo) === null || _caInfo === void 0 ? void 0 : _caInfo.caHash;
              if (caInfo) {
                _context6.next = 19;
                break;
              }
              key = Object.keys(localWallet.didWallet.caInfo)[0];
              caHash = localWallet.didWallet.caInfo[key].caHash;
              _context6.next = 18;
              return did.didWallet.getHolderInfoByContract({
                caHash: caHash,
                chainId: chainId
              });
            case 18:
              caInfo = _context6.sent;
            case 19:
              originChainId = enhancedLocalStorage.getItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              nickName = localWallet.didWallet.accountInfo.nickName || 'Wallet 01';
              if (!originChainId) {
                _context6.next = 26;
                break;
              }
              _context6.next = 24;
              return did.getCAHolderInfo(originChainId);
            case 24:
              holderInfo = _context6.sent;
              nickName = holderInfo.nickName;
            case 26:
              didWalletInfo = {
                caInfo: caInfo,
                pin: password,
                chainId: originChainId,
                walletInfo: localWallet.didWallet.managementAccount.wallet,
                accountInfo: localWallet.didWallet.accountInfo,
                createType: 'recovery'
              };
              portkeyInfo = _objectSpread(_objectSpread({}, didWalletInfo), {}, {
                accounts: _defineProperty({}, chainId, (_didWalletInfo$caInfo4 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo4 === void 0 ? void 0 : _didWalletInfo$caInfo4.caAddress),
                nickName: nickName
              });
              this._wallet = {
                name: nickName,
                address: (_didWalletInfo$caInfo5 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo5 === void 0 ? void 0 : _didWalletInfo$caInfo5.caAddress,
                extraInfo: {
                  publicKey: (didWalletInfo === null || didWalletInfo === void 0 ? void 0 : didWalletInfo.walletInfo.keyPair.getPublic('hex')) || '',
                  portkeyInfo: portkeyInfo
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              this.emit('connected', this._wallet);
              return _context6.abrupt("return", this._wallet);
            case 35:
              _context6.prev = 35;
              _context6.t0 = _context6["catch"](0);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_UNLOCK_FAIL, _context6.t0));
              return _context6.abrupt("return");
            case 40:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 35]]);
      }));
      function onUnlock(_x4) {
        return _onUnlock.apply(this, arguments);
      }
      return onUnlock;
    }()
  }, {
    key: "getSignature",
    value: function () {
      var _getSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
        var signInfo, signature;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (params.hexToBeSign) {
                console.error('getSignature: hexToBeSign is deprecated, please use signInfo instead, signInfo is utf-8 string not hex');
              }
              if (this._wallet) {
                _context7.next = 3;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 3:
              signInfo = '';
              if (params.hexToBeSign) {
                signInfo = params.hexToBeSign;
              } else {
                signInfo = params.signInfo;
              }
              signature = did.sign(signInfo).toString('hex');
              return _context7.abrupt("return", {
                error: 0,
                errorMessage: '',
                signature: signature,
                from: 'portkey'
              });
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getSignature(_x5) {
        return _getSignature.apply(this, arguments);
      }
      return getSignature;
    }()
  }, {
    key: "getAccountByChainId",
    value: function () {
      var _getAccountByChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(chainId) {
        var _this$_wallet;
        var accounts, _this$_wallet2, caInfo;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this._wallet) {
                _context8.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              accounts = (_this$_wallet = this._wallet) === null || _this$_wallet === void 0 || (_this$_wallet = _this$_wallet.extraInfo) === null || _this$_wallet === void 0 ? void 0 : _this$_wallet.portkeyInfo.accounts;
              if (!(!accounts || !accounts[chainId])) {
                _context8.next = 8;
                break;
              }
              _context8.next = 6;
              return did.didWallet.getHolderInfoByContract({
                caHash: (_this$_wallet2 = this._wallet) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.extraInfo) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.portkeyInfo) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.caInfo) === null || _this$_wallet2 === void 0 ? void 0 : _this$_wallet2.caHash,
                chainId: chainId
              });
            case 6:
              caInfo = _context8.sent;
              return _context8.abrupt("return", caInfo === null || caInfo === void 0 ? void 0 : caInfo.caAddress);
            case 8:
              return _context8.abrupt("return", accounts[chainId]);
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAccountByChainId(_x6) {
        return _getAccountByChainId.apply(this, arguments);
      }
      return getAccountByChainId;
    }()
  }, {
    key: "getWalletSyncIsCompleted",
    value: function () {
      var _getWalletSyncIsCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(chainId) {
        var _this$_wallet$extraIn, _didWalletInfo$caInfo6, _didWalletInfo$wallet;
        var didWalletInfo, caHash, address, originChainId, holder, filteredHolders;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this._wallet) {
                _context9.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              didWalletInfo = (_this$_wallet$extraIn = this._wallet.extraInfo) === null || _this$_wallet$extraIn === void 0 ? void 0 : _this$_wallet$extraIn.portkeyInfo;
              caHash = didWalletInfo === null || didWalletInfo === void 0 || (_didWalletInfo$caInfo6 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo6 === void 0 ? void 0 : _didWalletInfo$caInfo6.caHash;
              address = didWalletInfo === null || didWalletInfo === void 0 || (_didWalletInfo$wallet = didWalletInfo.walletInfo) === null || _didWalletInfo$wallet === void 0 ? void 0 : _didWalletInfo$wallet.address;
              originChainId = didWalletInfo === null || didWalletInfo === void 0 ? void 0 : didWalletInfo.chainId;
              if (!(originChainId === chainId)) {
                _context9.next = 8;
                break;
              }
              return _context9.abrupt("return", this._wallet.address);
            case 8:
              _context9.prev = 8;
              _context9.next = 11;
              return did.didWallet.getHolderInfoByContract({
                chainId: chainId,
                caHash: caHash
              });
            case 11:
              holder = _context9.sent;
              filteredHolders = holder.managerInfos.filter(function (manager) {
                return (manager === null || manager === void 0 ? void 0 : manager.address) === address;
              });
              if (!filteredHolders.length) {
                _context9.next = 17;
                break;
              }
              return _context9.abrupt("return", this._wallet.address);
            case 17:
              return _context9.abrupt("return", false);
            case 18:
              _context9.next = 23;
              break;
            case 20:
              _context9.prev = 20;
              _context9.t0 = _context9["catch"](8);
              return _context9.abrupt("return", false);
            case 23:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[8, 20]]);
      }));
      function getWalletSyncIsCompleted(_x7) {
        return _getWalletSyncIsCompleted.apply(this, arguments);
      }
      return getWalletSyncIsCompleted;
    }()
  }, {
    key: "getUrl",
    value: function getUrl() {
      return new URL(location.href);
    }
  }, {
    key: "getFaviconUrl",
    value: function getFaviconUrl(url) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      var hostUrl = new URL(url).host;
      return "https://icon.horse/icon/".concat(hostUrl, "/").concat(size);
    }
  }, {
    key: "sendAdapter",
    value: function () {
      var _sendAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref) {
        var _extraInfo;
        var caContract, chainId, contractAddress, methodName, args, sendOptions, didWalletInfo, chainInfo, _didWalletInfo$caInfo7, _didWalletInfo$caInfo8, _this$getUrl, origin, href, name, icon, originChainId, _ref2, amount, guardiansApproved, symbol, _didWalletInfo$caInfo9, params;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              caContract = _ref.caContract, chainId = _ref.chainId, contractAddress = _ref.contractAddress, methodName = _ref.methodName, args = _ref.args, sendOptions = _ref.sendOptions;
              didWalletInfo = (_extraInfo = this._wallet.extraInfo) === null || _extraInfo === void 0 ? void 0 : _extraInfo.portkeyInfo;
              _context10.next = 4;
              return getChain(chainId);
            case 4:
              chainInfo = _context10.sent;
              if (!((contractAddress === (chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.defaultToken.address) && methodName) === 'Approve')) {
                _context10.next = 18;
                break;
              }
              _this$getUrl = this.getUrl(), origin = _this$getUrl.origin, href = _this$getUrl.href, name = _this$getUrl.hostname;
              icon = this.getFaviconUrl(href);
              originChainId = didWalletInfo.chainId; // use amount from result of managerApprove not from params
              // dapp user may change amount at pop-up
              _context10.next = 11;
              return managerApprove(_objectSpread(_objectSpread({
                originChainId: originChainId,
                targetChainId: chainId,
                caHash: (_didWalletInfo$caInfo7 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo7 === void 0 ? void 0 : _didWalletInfo$caInfo7.caHash
              }, args), {}, {
                dappInfo: {
                  icon: icon,
                  href: origin,
                  name: name
                }
              }));
            case 11:
              _ref2 = _context10.sent;
              amount = _ref2.amount;
              guardiansApproved = _ref2.guardiansApproved;
              symbol = _ref2.symbol;
              return _context10.abrupt("return", caContract.callSendMethod('ManagerApprove', '', _objectSpread(_objectSpread({
                caHash: (_didWalletInfo$caInfo8 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo8 === void 0 ? void 0 : _didWalletInfo$caInfo8.caHash
              }, args), {}, {
                guardiansApproved: guardiansApproved,
                amount: amount,
                symbol: symbol
              }), sendOptions));
            case 18:
              params = {
                caHash: (_didWalletInfo$caInfo9 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo9 === void 0 ? void 0 : _didWalletInfo$caInfo9.caHash,
                contractAddress: contractAddress,
                methodName: methodName,
                args: args
              };
              return _context10.abrupt("return", caContract.callSendMethod('ManagerForwardCall', didWalletInfo.walletInfo.address, params, sendOptions));
            case 20:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function sendAdapter(_x8) {
        return _sendAdapter.apply(this, arguments);
      }
      return sendAdapter;
    }()
  }, {
    key: "getContract",
    value: function () {
      var _getContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(chainId, contractAddress) {
        var _this$_wallet$extraIn2;
        var chainsInfo, chainInfo;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (this._wallet) {
                _context11.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              _context11.next = 4;
              return did.services.getChainsInfo();
            case 4:
              chainsInfo = _context11.sent;
              chainInfo = chainsInfo.find(function (chain) {
                return chain.chainId === chainId;
              });
              if (chainInfo) {
                _context11.next = 8;
                break;
              }
              throw new Error("chain is not running: ".concat(chainId));
            case 8:
              return _context11.abrupt("return", getContractBasic({
                contractAddress: contractAddress || chainInfo.caContractAddress,
                account: (_this$_wallet$extraIn2 = this._wallet.extraInfo) === null || _this$_wallet$extraIn2 === void 0 ? void 0 : _this$_wallet$extraIn2.portkeyInfo.walletInfo,
                rpcUrl: chainInfo.endPoint
              }));
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getContract(_x9, _x10) {
        return _getContract.apply(this, arguments);
      }
      return getContract;
    }()
  }, {
    key: "callSendMethod",
    value: function () {
      var _callSendMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref3) {
        var chainId, contractAddress, methodName, args, sendOptions, finalChainId, contract, adapterProps, rs;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              chainId = _ref3.chainId, contractAddress = _ref3.contractAddress, methodName = _ref3.methodName, args = _ref3.args, sendOptions = _ref3.sendOptions;
              if (this._wallet) {
                _context12.next = 3;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 3:
              if (contractAddress) {
                _context12.next = 5;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 5:
              finalChainId = chainId || this._config.chainId;
              _context12.next = 8;
              return this.getContract(finalChainId);
            case 8:
              contract = _context12.sent;
              adapterProps = {
                caContract: contract,
                chainId: finalChainId,
                contractAddress: contractAddress,
                methodName: methodName,
                args: args,
                sendOptions: sendOptions
              };
              _context12.next = 12;
              return this.sendAdapter(adapterProps);
            case 12:
              rs = _context12.sent;
              return _context12.abrupt("return", rs);
            case 14:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function callSendMethod(_x11) {
        return _callSendMethod.apply(this, arguments);
      }
      return callSendMethod;
    }()
  }, {
    key: "callViewMethod",
    value: function () {
      var _callViewMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref4) {
        var chainId, contractAddress, methodName, args, finalChainId, contract, rs;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              chainId = _ref4.chainId, contractAddress = _ref4.contractAddress, methodName = _ref4.methodName, args = _ref4.args;
              if (this._wallet) {
                _context13.next = 3;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 3:
              if (contractAddress) {
                _context13.next = 5;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 5:
              finalChainId = chainId || this._config.chainId;
              _context13.next = 8;
              return this.getContract(finalChainId, contractAddress);
            case 8:
              contract = _context13.sent;
              rs = contract.callViewMethod(methodName, args);
              return _context13.abrupt("return", rs);
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function callViewMethod(_x12) {
        return _callViewMethod.apply(this, arguments);
      }
      return callViewMethod;
    }()
  }]);
  return PortkeyAAWallet;
}(BaseWalletAdapter);